var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-item-group',{staticClass:"zone-group",attrs:{"multiple":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm._l((_vm.items),function(item,i){return _c('v-item',{key:item,attrs:{"value":item},scopedSlots:_vm._u([{key:"default",fn:function({ active, toggle }){return [_c('div',{staticClass:"zone",class:[
        `zone-${item}`,
        `zone-index-${i}`,
        { 'side-zone ': item > 10 },
        { active: active }
      ],on:{"click":toggle}},[_c('span',{staticClass:"zone-value"},[_vm._v(_vm._s(item))])])]}}],null,true)})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }